import React, { useEffect, useState } from "react";
import AddPayment from "../AddPayment";
import Spinner from "../Spinner";
import { showPaymentModal } from "../../redux/actions";
import { PRIMARY, SECONDARY } from "../../constants";
import { Box } from "@mui/material";
import { addCustomerCard, sendGoogleAnalytics } from "../../api";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import {
  analyticsEvents,
  PAGES,
  PROVENANCE,
} from "../../utils/firebaseAnalytics";
import { ModalCard, Button } from "@dishopsaas/design-system";
import ModalBody from "../ModalBody/ModalBody.view";
export default function PaymentModal({ stripe, elements }) {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [selectedCard] = useState({ id: '' });
  const { paymentModal } = useAppSelector((state) => state.componentReducer);
  useEffect(() => {
    if (paymentModal) {

      analyticsEvents.logPageViewEvent(
        PAGES.PAYMENT,
        PROVENANCE.CART_PAGE
      );
    }
  }, [paymentModal]);

  return (
    <ModalCard open={paymentModal} maxWidth={440} sxModal={{ p: 0 }} onClose={() => {
      dispatch(showPaymentModal(false));
    }}>
      <ModalBody
        title="Ajout d'une nouvelle carte"
        onClose={() => {
          if (!loading) dispatch(showPaymentModal(false));
        }}
        footer={
          <Box
            sx={{
              display: "flex",
              width: "100%",
              ...(loading
                ? {
                  justifyContent: "center",
                  alignItems: "center",
                }
                : {
                  gap: 4,
                }),
            }}
          >
            {loading ? (
              <Spinner />
            ) : (
              <>
                <Button
                  label="Fermer"
                  colorType={SECONDARY}
                  onClick={() => dispatch(showPaymentModal(false))}
                  sx={{ flex: 1 }}
                  size="large"
                />

                <Button
                  label="AJOUTER LA CARTE"
                  colorType={PRIMARY}
                  size="large"
                  onClick={async () => {
                    setLoading(true);
                    const card = await addCustomerCard(
                      stripe,
                      elements,
                      true
                    );
                    setLoading(false);
                    if (card) {
                      dispatch(showPaymentModal(false));
                    }
                    sendGoogleAnalytics("add_payment_info", {});
                    analyticsEvents.logPaymentInfo(selectedCard.id);
                  }}
                  sx={{ flex: 3 }}
                />
              </>
            )}
          </Box>
        }
      >
        <>
          <AddPayment />
          {/* <Box
            sx={{
              display: "flex",
              padding: "4px 0",
              justifyContent: "space-between",
              alignItems: "center",
              alignSelf: "stretch",
              width: "100%",
            }}
          >
            <Typography variant="body1">
              Ajouter comme Paiement par défaut
            </Typography>

            <Toggle checked={checked} onChange={setChecked} />
          </Box> */}
        </>
      </ModalBody>
    </ModalCard>
  );
}
